// @flow
import { createContext } from 'react';

import type { BannerProps } from './banners-types';


export const defaultBannersState = {};

type BannersContextType = {
  data: {
    getBannerDataByPlaceId: (placeId: string) => BannerProps | null,
  },
  effects: {
    refreshBannerByPlaceId: (placeId: string) => void,
    pauseBannerByPlaceId: (placeId: string) => void,
  },
}

const defaultContext: BannersContextType = {
  data: {
    getBannerDataByPlaceId: () => null,
  },
  effects: {
    refreshBannerByPlaceId: () => {},
    pauseBannerByPlaceId: () => {},
  },
};

export default createContext<BannersContextType>(defaultContext);
